import { render, staticRenderFns } from "./WinLoseLog.vue?vue&type=template&id=b06c8d92&scoped=true"
import script from "./WinLoseLog.vue?vue&type=script&lang=ts"
export * from "./WinLoseLog.vue?vue&type=script&lang=ts"
import style0 from "./WinLoseLog.vue?vue&type=style&index=0&id=b06c8d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06c8d92",
  null
  
)

export default component.exports